import React from 'react';
import { Select } from 'antd';

const LanguageSelector = ({ selectedLanguage, languageList, switchLanguage }) => {
  const langDescMap = {
    python3: 'Python 3',
    ruby3: 'Ruby 3',
    javascript: 'Javascript',
    cpp: 'C++',
    java: 'Java',
    c: 'C',
  };

  return (
    <Select
      value={selectedLanguage}
      id="menuList"
      style={{ fontSize: '16px', padding: '0px', textAlign: 'left' }}
      onChange={e => switchLanguage(e)}
      options={languageList.map(l => ({
        value: l,
        label: langDescMap[l],
      }))}
    />
  );
};

export default LanguageSelector;
